import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/login',
    name: 'login',
    component: { render: h => h('router-view') },
    children: [{
      hiddenInMenu: true,
      meta: { icon: 'bar-chart', title: '登录', messageKey: 'message.menu.demoDashboard' },
      name: 'analysis',
      path: '/login',
      component: () =>
        import(
          /* webpackChunkName: "dashboard" */
          '../views/Login'
          )
    }]
  },
  {
    path: '/',
    component: () =>
      import(/* webpackChunkName: "layout" */ '../layouts/BasicLayout'),
    children: [
      {
        path: '/',
        redirect: '/dashboard/workbench'
      },
      {
        path: '/icp/task',
        meta: { title: '报表Demo', messageKey: 'message.menu.taskCenterItem'},
        name: 'taskCenter',
        hideInMenu: true,
        component: () =>
          import(
            '../views/icp/TaskCenter'
            )

      }, {
        path: '/feedback',
        name: 'feedback',
        hideInMenu: true,
        meta: {title: '反馈', messageKey: 'message.menu.feedback.feedbackName'},
        component: {render: h => h('router-view')},
        children: [{
          path: '/feedback/dashboardScore',
          hideInMenu: true,
          meta: {icon: 'bar-chart', title: '报表评分', messageKey: 'message.menu.feedback.dashboardScore'},
          name: 'analysis',
          component: () =>
            import(
              '../views/Feedback/DashboardScore'
              )
        }, {
          path: '/feedback/systemFeedback',
          hideInMenu: true,
          meta: {icon: 'bar-chart', title: '意见反馈', messageKey: 'message.menu.feedback.feedback'},
          name: 'analysis',
          component: () =>
            import(
              '../views/Feedback/Feedback'
              )
        } ]
      },
      {
        path: '/helpcenter',
        hideInMenu: true,
        meta: {title: '帮助中心', messageKey: 'message.button.helpCenter'},
        name: 'helpcenter',
        component: () =>
          import(
            '../views/helpcenter/HelpCenter'
          )
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        meta: {icon: 'dashboard', title: '工作台', messageKey: 'message.menu.workbench', iconfont: 'icon-Workbench'},
        component: {render: h => h('router-view')},
        children: [ {
          path: '/dashboard/workbench',
          meta: { icon: 'bar-chart', title: '报表', messageKey: 'message.menu.dashboard', iconfont: 'icon-Dashboard'},
          name: 'workbench',
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */
              '../views/Dashboard/Analysis'
              )
        }]
      },
      {
        path: '/item',
        name: 'item',
        meta: {icon: 'shopping', title: '商货品', messageKey: 'message.menu.item', iconfont: 'icon-ProductAndCargo'},
        component: {render: h => h('router-view')},
        children: [
          {
            path: '/item/product',
            meta: {icon: 'inbox', title: '商品视图', messageKey: 'message.menu.productView', iconfont: 'icon-Product'},
            name: 'product',
            component: () =>
              import(
                /* webpackChunkName: "dashboard" */
                '../views/Item/ProductView'
                )
          },
          {
            path: '/item/scItemView',
            meta: {icon: 'gold', title: '货品视图', messageKey: 'message.menu.scItemView', iconfont: 'icon-Cargo'},
            name: 'scItemView',
            component: () =>
              import(
                /* webpackChunkName: "dashboard" */
                '../views/Item/ScItemView'
                )
          },
          {
            path: '/item/ProductPublishView',
            meta: {icon: 'file-add', title: '发布视图', messageKey: 'message.menu.productPublishView', iconfont: 'icon-ProductDeploy'},
            name: 'productPublishView',
            component: () =>
              import(
                /* webpackChunkName: "dashboard" */
                '../views/Item/ProductPublishView'
                )
          },
          {
            path: '/item/PublishTemplateView',
            meta: {icon: 'container', title: '货品视图', messageKey: 'message.menu.publishTemplateView', iconfont: 'icon-ProductDeployTemplate'},
            name: 'publishTemplateView',
            component: () =>
              import(
                '../views/Item/PublishTemplateView'
                )
          }
        ]
      },
      {
        path: '/inoutbound',
        name: 'inoutbound',
        meta: {title: '出入库', icon: 'dashboard', messageKey: 'message.menu.inOutBound', iconfont: 'icon-InOutBound'},
        component: {render: h => h('router-view')},
        children: [{
          path: '/icp/inbound',
          meta: { title: '报表Demo', messageKey: 'message.menu.inboundItemName', iconfont: 'icon-Inbound'},
          name: 'inbound',
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */
              '../views/icp/Inbound'
              )
        }, {
          path: '/icp/inboundDetail:purchaseNo',
          meta: {title: '报表Demo', messageKey: 'message.menu.inboundItemName'},
          name: 'inboundDetail',
          hideInMenu: true,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */
              '../views/icp/InboundDetail'
              )
        }, {
          path: '/icp/lzdinboundDetail:purchaseNo',
          meta: { title: '报表Demo', messageKey: 'message.menu.inboundItemName'},
          name: 'lzdinboundDetail',
          hideInMenu: true,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */
              '../views/icp/LazadaInboundDetail'
              )
        }, {
          path: '/icp/LzdOutboundDetail:purchaseNo',
          meta: { title: '报表Demo', messageKey: 'message.menu.outboundItem'},
          name: 'LzdOutboundDetail',
          hideInMenu: true,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */
              '../views/icp/LazadaOutboundDetail'
              )
        }, {
          path: '/icp/CreateInAndOutBound:purchaseNo',
          meta: { title: '报表Demo', messageKey: 'message.menu.createNewInboundOrder'},
          name: 'createNewInboundOrder',
          hideInMenu: true,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */
              '../views/icp/CreateInBound'
            )
        }, {
          path: '/icp/outBound:purchaseNo',
          meta: { title: '报表Demo', messageKey: 'message.menu.createNewOutboundOrder'},
          name: 'createNewOutboundOrder',
          hideInMenu: true,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */
              '../views/icp/CreateOutBound'
            )
        }, {
          path: '/icp/AegOutboundDetail:purchaseNo',
          meta: { title: '报表Demo', messageKey: 'message.menu.outboundItem'},
          name: 'aegOutboundDetail',
          hideInMenu: true,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */
              '../views/icp/AegOutboundDetail'
              )
        }, {
          path: '/icp/outbound',
          meta: { title: '报表Demo', messageKey: 'message.menu.outboundItem', iconfont: 'icon-Outbound'},
          name: 'outboundList',
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */
              '../views/icp/Outbound'
              )
        }, {
          path: '/icp/inboundPlan',
          meta: { title: '报表Demo', messageKey: 'message.menu.inboundPlanItem', iconfont: 'icon-ReplenishPlan'},
          name: 'inboundPlan',
          // hideInMenu: true,
          component: () =>
            import(
              '../views/icp/InboundPlan'
              )
        }, {
          path: '/icp/inboundPlanDetail:inboundPlanDetailData',
          meta: { title: '报表Demo', messageKey: 'message.menu.inboundPlanItemDetail'},
          name: 'inboundPlanDetail',
          hideInMenu: true,
          component: () =>
            import(
              '../views/icp/LazadaInboundPlanDetail'
              )
        }
        ]
      },
      {
        path: '/inventory',
        name: 'inventory',
        meta: {icon: 'dashboard', title: '库存', messageKey: 'message.menu.inventory', iconfont: 'icon-Inventory'},
        component: {render: h => h('router-view')},
        children: [{
          path: '/inventory/stockAllocation',
          meta: {icon: 'bar-chart', title: '库存分配', messageKey: 'message.menu.stockAllocation', iconfont: 'icon-ChannelInventory'},
          name: 'analysis',
          component: () =>
            import(
              '../views/inventory/ManageStockAllocation'
              )
        }, {

          //   path: '/inventory/liveInventory',
          //   name: 'liveInventory',
          //   meta: {icon: 'home', title: '实时库存', messageKey: 'message.menu.liveInventory', iconfont: 'icon-LiveInventory'},
          //   component: () => import('../views/inventory/LiveInventory')
          // }, {
          path: '/inventory/activityInventory',
          meta: {icon: 'bar-chart', title: '活动库存', messageKey: 'message.menu.activityInventory', iconfont: 'icon-ChannelInventory'},
          name: 'analysis',
          component: () =>
            import(
              '../views/inventory/ActivityInventory'
              )
        },
          {

            path: '/inventory/inventoryAging',
            meta: {icon: 'bar-chart', title: '库龄', messageKey: 'message.menu.inventoryAging', iconfont: 'icon-ChannelInventory'},
            name: 'analysis',
            component: () =>
              import(
                '../views/inventory/InventoryAging'
                )
          },
          {
        //   path: '/inventory/liveInventory',
        //   name: 'liveInventory',
        //   meta: {icon: 'home', title: '实时库存', messageKey: 'message.menu.liveInventory', iconfont: 'icon-LiveInventory'},
        //   component: () => import('../views/inventory/LiveInventory')
        // }, {

          path: '/inventory/liveInventory',
          name: 'liveInventory',
          meta: {icon: 'home', title: '实时库存', messageKey: 'message.menu.liveInventory', iconfont: 'icon-LiveInventory'},
          component: () => import('../views/inventory/LiveInventoryGroupByCargo')
        }, {
          path: '/inventory/inventoryReconciliation',
          name: 'inventoryReconciliation',
          meta: {icon: 'home', title: '库存对账', messageKey: 'message.menu.inventoryReconciliation', iconfont: 'icon-InventoryReconciliation'},
          component: () => import('../views/inventory/InventoryReconciliation')
        }, {
          path: '/inventory/inventoryLedger',
          name: 'inventoryLedger',
          meta: {icon: 'home', title: '库存流水', messageKey: 'message.menu.inventoryLedger', iconfont: 'icon-InventoryLedger'},
          component: () => import('../views/inventory/InventoryLedger')
        }]

      },
      {

        path: '/fulfillment',
        name: 'fulfillment',
        meta: {icon: 'dashboard', title: '履约', messageKey: 'message.menu.fulfillment', iconfont: 'icon-Fulfillment'},
        component: {render: h => h('router-view')},
        children: [{
          path: '/fulfillment/order',
          meta: {icon: 'bar-chart', title: '订单', messageKey: 'message.menu.fulfillmentOrder', iconfont: 'icon-IndustryOrder'},
          name: 'fulfillmentOrder',
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */
              '../views/Fulfillment/Order'
              )
        }, {
          path: '/fulfillment/order/detail',
          meta: {icon: 'bar-chart', title: '订单详情', messageKey: 'message.menu.fulfillmentOrderDetail'},
          name: 'orderDetail',
          hideInMenu: true,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */
              '../views/Fulfillment/OrderDetail'
              )
        }
          // , {
          //   path: '/cb/fulfillment/order',
          //   meta: {icon: 'bar-chart', title: '跨境订单', messageKey: 'message.menu.cbFulfillmentOrder'},
          //   name: 'cbFulfillmentOrder',
          //   component: () =>
          //     import(
          //       /* webpackChunkName: "dashboard" */
          //       '../views/Fulfillment/CbOrder'
          //     )
          // },
        ]
      },
      {
        path: '/authorization',
        name: 'authorization',
        meta: { icon: 'dashboard', title: '店铺授权', messageKey: 'message.menu.authorization.title', iconfont: 'icon-ShopAuthorization' },
        component: { render: h => h('router-view') },
        children: [{
          path: '/authorization/auth',
          meta: { icon: 'bar-chart', title: '授权', messageKey: 'message.menu.authorization.auth', iconfont: 'icon-Authorization' },
          name: 'authorization',
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */
              '../views/authorization/authorization'
              )
        },
          {
            path: '/authorization/OwnerTransfer',
            meta: {icon: 'bar-chart', title: '店铺绑定', messageKey: 'message.menu.ownerTransfer.title', iconfont: 'icon-CargoTranslate'},
            name: 'ownerTransfer',
            component: () =>
              import(
                /* webpackChunkName: "dashboard" */
                '../views/authorization/OwnerTransfer'
                )
          }
        ]
      },
      {
        path: '/gfc/enter',
        meta: { icon: 'bar-chart', title: '中心仓入驻', messageKey: 'message.menu.gfc.enter', iconfont: 'icon-WarehouseSettled' },
        name: 'gfcEnter',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */
            '../views/gfc/authorization'
            )
      }
    ]
  }
]
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})

router.beforeEach((to, form, next) => {
  NProgress.start()
  next()
})
router.afterEach(() => {
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js